import { addDays, differenceInCalendarDays, format, isValid, parseISO } from 'date-fns';

/**
 * scheduledFor is a calendar date stored as midnight UTC ("2026-09-12T00:00:00.000Z"). Formatting
 * that instant in the browser's zone would show 09-11 to anyone west of UTC, so every helper here
 * reads the UTC calendar parts and rebuilds them as a local date before formatting or comparing.
 */
const utcCalendarDay = (value) => {
  const parsed = typeof value === 'string' ? parseISO(value) : value;
  if (!isValid(parsed)) return null;
  return new Date(parsed.getUTCFullYear(), parsed.getUTCMonth(), parsed.getUTCDate());
};

/** Dates in the Fill Later queue are MM-DD-YYYY, matching the Scheduled Date Range picker. */
export const formatScheduledDate = (value) => {
  if (!value) return 'N/A';
  const day = utcCalendarDay(value);
  return day ? format(day, 'MM-dd-yyyy') : 'N/A';
};

/**
 * "in 3 days" / "today" / "3 days ago" - shown only while the row is still actionable.
 * "Today" is the UTC calendar day, the same clock the backend and the scheduler use.
 */
export const relativeScheduledText = (value, now = new Date()) => {
  const diff = differenceInCalendarDays(utcCalendarDay(value), utcCalendarDay(now));
  if (diff === 0) return { text: 'today', overdue: true };
  if (diff > 0) return { text: `in ${diff} ${diff === 1 ? 'day' : 'days'}`, overdue: false };
  const days = Math.abs(diff);
  return { text: `${days} ${days === 1 ? 'day' : 'days'} ago`, overdue: true };
};

/**
 * Earliest date "Change the date" may offer: the day after today in UTC, which is what the
 * backend enforces. A US user late in the evening is already on tomorrow's UTC day, so a local
 * "tomorrow" could be rejected as "today".
 */
export const minRescheduleDate = (now = new Date()) => addDays(utcCalendarDay(now), 1);
